import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { MessageSquarePlus, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { isMobileApp } from "../lib/platform";

export default function FeedbackWidget() {
    const { user } = useAuth();
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState("");
    const [sending, setSending] = useState(false);

    // Only for signed-in users, and never on top of the shared read-only view.
    if (!user || location.pathname.startsWith("/s/")) return null;

    const send = async () => {
        if (msg.trim().length < 3) return;
        setSending(true);
        try {
            await api.post("/feedback", {
                message: msg.trim(),
                page: location.pathname,
                platform: isMobileApp() ? "app" : "web",
            });
            toast.success("Thanks — feedback sent!");
            setMsg("");
            setOpen(false);
        } catch {
            toast.error("Couldn't send right now — please try again in a minute.");
        }
        setSending(false);
    };

    return (
        <div className="fixed bottom-4 right-4 z-40" data-testid="feedback-widget">
            {open && (
                <div className="mb-3 w-72 border border-ink/20 bg-white shadow-xl p-4" data-testid="feedback-panel">
                    <div className="flex items-center justify-between mb-2">
                        <span className="ui-heading text-xs uppercase tracking-widest text-ink-soft">/ feedback</span>
                        <button onClick={() => setOpen(false)} aria-label="Close feedback" data-testid="feedback-close">
                            <X size={16} />
                        </button>
                    </div>
                    <textarea
                        value={msg}
                        onChange={(e) => setMsg(e.target.value)}
                        rows={4}
                        maxLength={4000}
                        placeholder="Found a bug? Missing a feature? Tell us — we read every note."
                        className="w-full border border-ink/20 px-3 py-2 text-sm bg-white focus-cobalt resize-none"
                        data-testid="feedback-message-input"
                    />
                    <button
                        onClick={send}
                        disabled={sending || msg.trim().length < 3}
                        className="btn-brutal mt-2 w-full bg-cobalt hover:bg-cobalt-hover text-white px-3 py-2 ui-heading text-sm font-semibold border border-cobalt disabled:opacity-50"
                        data-testid="feedback-send-button"
                    >
                        {sending ? "Sending…" : "Send feedback"}
                    </button>
                </div>
            )}
            {!open && (
                <button
                    onClick={() => setOpen(true)}
                    aria-label="Send feedback"
                    className="btn-brutal inline-flex items-center gap-2 border border-ink/20 bg-white px-3 py-2 ui-heading text-xs font-semibold shadow-lg"
                    data-testid="feedback-open-button"
                >
                    <MessageSquarePlus size={15} /> Feedback
                </button>
            )}
        </div>
    );
}
